exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ntd[data-v-9a39ca1c] {\n  color: #010906;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-recon/features/billing/pages/files/components/BillingExtractionsTable.vue"],"names":[],"mappings":";AA4DA;EACE,eAAc;CACf","file":"BillingExtractionsTable.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import \"~@intelipost-js/secure-ui/src/scss/variables\"; //eslint-disable-line\n\ntd {\n  color: #010906;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9a39ca1c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/files/components/BillingExtractionsTable.vue
// module id = fVl1
// module chunks = 72